import { render, staticRenderFns } from "./AssociaDiariPresidiModalComponent.vue?vue&type=template&id=033e56b8"
import script from "./AssociaDiariPresidiModalComponent.vue?vue&type=script&lang=js"
export * from "./AssociaDiariPresidiModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports